<template>
  <label class="textarea-editor"
         :class="class_list">
    <span class="textarea-editor_label">{{ label }}</span>
    <textarea
      ref="textarea"
      class="textarea-editor__item"
      placeholder="Empty placeholder"
      :disabled="disabled"
      :readonly="read_only"
      v-html="value"
      :class="get_uniq_class"></textarea>
  </label>
</template>

<script>

import tinymce from "tinymce"
import 'tinymce/themes/silver'
import 'tinymce/plugins/code';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/link';

export default {
  name: "TextareaEditor",
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    read_only: {
      type: Boolean,
      default: false
    },
    init_mce: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tinymce: false
    }
  },
  mounted() {
    if (this.init_mce) {
      this.initEditor()
    }
  },
  computed: {
    class_list() {
      return {
        darker_border: this.darker_border,
        disabled: this.disabled,
        error: this.error
      }
    },
    get_uniq_class() {
      return `textarea-editor__item_${this._uid}`
    },

  },
  methods: {
    initEditor() {
      this.tinymce = tinymce.init({
        api_key: 'nk924kdros3z5t81ja9jv7357u2bbe8urpwyl23yo2u5gbp4',
        convert_urls: false,
        selector: `textarea.${this.get_uniq_class}`,
        placeholder: this.label,
        table_sizing_mode: 'fixed',
        table_use_colgroups: false,
        plugins: `link code lists advlist table | media`,
        toolbar: 'undo redo | blocks removeformat | alignleft aligncenter alignright alignjustify ' +
          '| bold italic | table tabledelete | bullist numlist | link unlink | code | link image emoticons | media',
        height: 820,
        table_cell_class_list: [
          { title: 'None', value: '' },
          { title: 'Text no wrap', value: 'text_nowrap' },
        ],
        setup: (editor) => {
          editor.on('input', (e) => {
            this.$emit('input', this.addTableWrapper(e.target.innerHTML))
          });
          editor.on('ExecCommand', (e) => {
            let content = e.target.getContent();
            if (!content) return
            this.$emit('input', this.addTableWrapper(content))
          });
        }
      });
    },
    addTableWrapper(value) {
      if (!value.includes('<table')) {
        return value
      }
      return value.replace(/<table[^>]*>[\s\S]*?<\/table>/g, '<div class="table-wrapper">$&</div>')
        .replaceAll('\n', '')
        .replace(/(<div class="table-wrapper">){2,}/g, '<div class="table-wrapper">')
        .replace(/(<\/div>){2,}/g, '</div>')
    },
    destroyEditor() {
      document.querySelectorAll('.tox.tox-silver-sink.tox-tinymce-aux').forEach(tox_box => {
        tox_box.innerHTML = ''
      })
      tinymce.remove(`textarea.${this.get_uniq_class}`)
    }
  },
  beforeDestroy() {
    this.destroyEditor()
  },
  watch: {
    'init_mce'(val) {
      if (val) {
        this.initEditor()
      } else {
        this.destroyEditor()
      }
    }
  }
}
</script>
